module.exports = __webpack_public_path__ + "static/img/erweima3.a260b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/erweima3.png
// module id = lljd
// module chunks = 16